import { makeSafeFn } from '../../utils/fn'
import { getInfluencerId, getUserPlatform } from '../../utils/pageContext'
import { getLastKnownCountryCode } from '../../providers/geolocationProvider'
import {
  linksCounter,
  linksDescription,
} from '../../../components/postBodyLinks/postBodyLinksCounter'
import { trackUserIdentifier } from '../../../components/googleAnalyticaSessionTracker/useridentifierTracker'
import getTrafficInfo from '../vms/ads/trafficAnalyzer'

function gtmScriptTemplate(ids) {
  return ids.forEach(id => {
    ;(function(w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', id)
  })
}

function pushPageViewDataToGtm(gtmData) {
  function getQueryAttrFromURI(attrName) {
    const qryString = window.location.search
    const rgx = new RegExp(attrName + '=[a-z0-9]*', 'i')
    const rgxResult = rgx.exec(qryString)

    return rgxResult !== null ? rgxResult[0].split('=')[1] : null
  }

  function safeGetIsUserAuthenticated() {
    try {
      return JSON.parse(localStorage.CurrentUser).authenticated
    } catch (e) {
      return false
    }
  }

  const gtmEventsData = Object.keys(gtmData).reduce(
    function(accumulator, keyVal) {
      accumulator[keyVal] = gtmData[keyVal]

      return accumulator
    },
    { event: 'GTM data ready to GA' }
  )

  gtmEventsData.platform = getUserPlatform()
  gtmEventsData.userIsConnected = safeGetIsUserAuthenticated()
  gtmEventsData.geoDetected = getLastKnownCountryCode()
  gtmEventsData.inArticleLinksNum = linksCounter()
  gtmEventsData.inArticleLinks = linksDescription()
  gtmEventsData.mmUserIdentifier = trackUserIdentifier()

  const { trafficSource, trafficId } = getTrafficInfo()
  gtmEventsData.trafficSource = trafficSource
  gtmEventsData.trafficId = trafficId

  const aID = getInfluencerId()

  if (aID !== null) {
    gtmEventsData.affiliateId = aID
  }
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(gtmEventsData)
}

export function getGtmScriptConfig(ids, gtmData) {
  return {
    src: () => {},
    beforeLoad: makeSafeFn(() => {
      pushPageViewDataToGtm(gtmData)
      gtmScriptTemplate(ids)
      return false
    }),
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/gtmScriptConfig.js